import { Link } from '@/lib/nav';
import { Container, Section, Eyebrow } from '@/components/primitives/Container';
import { ROUTES } from '@/lib/routes';

export function NotFound() {
  return (
    <Section className="pt-20">
      <Container width="editorial">
        <Eyebrow>404</Eyebrow>
        <h1 className="mt-4 font-serif text-4xl font-normal tracking-tight sm:text-5xl">
          La página que buscás no existe.
        </h1>
        <p className="mt-6 max-w-prose text-lg leading-relaxed text-ink-muted">
          El sistema curricular argentino es complejo. Esta página, en cambio, es simple: no está.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to={ROUTES.home}
            className="focus-ring rounded-full bg-ink px-5 py-2.5 text-sm font-medium text-paper hover:bg-ink-muted"
          >
            Volver al inicio
          </Link>
          <Link
            to={ROUTES.glosario}
            className="focus-ring rounded-full border border-line_strong px-5 py-2.5 text-sm font-medium text-ink hover:border-ink hover:bg-ink hover:text-paper"
          >
            Ir al glosario
          </Link>
        </div>
      </Container>
    </Section>
  );
}
